const translations = {
  "en": {
    "Here's what I noticed:": "Here's what I noticed:",
    "Meet Ed": "Meet Ed",
    "Read it. Three things stand out from your portfolio.": "Read it. Three things stand out from your portfolio.",
    "See the trackers": "See the trackers"
  },
  "zh-tw": {
    "Here's what I noticed:": "我注意到的是：",
    "Meet Ed": "認識 Ed",
    "Read it. Three things stand out from your portfolio.": "讀一下。你的投資組合中有三件事值得注意。",
    "See the trackers": "查看追蹤器"
  }
};

export default translations;
